import { createEvent } from 'effector';
import { type PayoutTicket } from '~/entities/payout';
import { openTicketModal } from './lib';

export const openTicket = createEvent<PayoutTicket>();
openTicket.watch(openTicketModal);
